import * as React from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import {
    Box,
    Button,
    CardActions,
    Grid,
    IconButton,
    OutlinedInput,
    Stack,
    Tooltip,
} from '@mui/material';
import { CopyOutlined } from '@ant-design/icons';
// third-party
import { CopyToClipboard } from 'react-copy-to-clipboard';
// project import
import ConfirmationModal from 'components/modal/ConfirmationModal';
import CamelCaseToKebabCase from 'utils/helpers/CamelCaseToKebabCase';

const ActionCopyValue = ({ value, title, children }) => {
    const { enqueueSnackbar } = useSnackbar();

    const [openModal, setOpenModal] = React.useState(false);

    const handleOpenConfirmationModal = () => {
        setOpenModal(true);
    };

    const handleCloseConfirmationModal = () => {
        setOpenModal(false);
    };
    const handleClick = () => {
        enqueueSnackbar('Copied', { variant: 'success' });
        handleCloseConfirmationModal();
    };
    return (
        <>
            <ConfirmationModal
                onClose={handleCloseConfirmationModal}
                isOpen={openModal}
                title={title || 'Copy'}
                renderActions={() => (
                    <>
                        <Button
                            onClick={handleCloseConfirmationModal}
                            variant="outlined"
                            color="secondary"
                        >
                            Cancel
                        </Button>
                    </>
                )}
            >
                <Grid item xs={12} display={'flex'} sx={{}}>
                    <Grid item sx={{ flex: '1 1 auto' }}>
                        <Stack spacing={1}>
                            <OutlinedInput
                                fullWidth
                                id={CamelCaseToKebabCase(value)}
                                type={'text'}
                                value={value}
                                name={value}
                            />
                        </Stack>
                    </Grid>
                    <Grid
                        item
                        sx={{ flex: '0 1 auto' }}
                        display={'flex'}
                        alignItems={'end'}
                    >
                        <CardActions
                            sx={{
                                justifyContent: 'flex-start',
                                p: 1,
                                display: 'inline-block',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    position: 'inherit',
                                    right: 0,
                                    top: 6,
                                }}
                                onClick={handleClick}
                            >
                                <CopyToClipboard text={value || ''}>
                                    <Tooltip title="Copy" placement="top-start">
                                        <IconButton
                                            color="secondary"
                                            size="small"
                                            sx={{ fontSize: '0.875rem' }}
                                        >
                                            <CopyOutlined />
                                        </IconButton>
                                    </Tooltip>
                                </CopyToClipboard>
                            </Box>
                        </CardActions>
                    </Grid>
                </Grid>
            </ConfirmationModal>
            <Stack onClick={handleOpenConfirmationModal}>{children}</Stack>
        </>
    );
};
ActionCopyValue.propTypes = {
    value: PropTypes.string.isRequired,
    title: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default ActionCopyValue;
